import {useState,useEffect, useRef} from 'react'
import Slider from "react-slick";
import sanityClient from '../../sanityClient'; 
// import { Link } from "react-router-dom";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faPlay, faPause } from '@fortawesome/free-solid-svg-icons';

export default function HomeFacility({isAbout, facilityContent}) {
  const [facilities, setFacilities] = useState([]);

  const [homeFacilityContent, setHomeFacilityContent] = useState({ heading: '', description: '' });
  const [bannerData, setBannerData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isPlaying, setIsPlaying] = useState(false); // State to track video play/pause
    const videoRef = useRef(null); 

    

    useEffect(() => {
        sanityClient.fetch(`*[_type == "homePageContent"][0].homeFacility{heading, description}`)
            .then((data) => setHomeFacilityContent(data))
            .catch(console.error);
    }, []);
    useEffect(() => {
      const fetchBannerData = async () => {
        try {
          const query = `*[_type == "bannerImageSection" && page == "homefacilitySection"][0]{
            bannerType,
            "imageUrl": bannerImage.asset->url,
            bannerVideoUrl,
            altText,
            
          }`;
  
          const data = await sanityClient.fetch(query);
          setBannerData(data);
        } catch (error) {
          console.error('Error fetching banner data:', error);
        } finally {
          setLoading(false); // Ensure loading state is updated
        }
      };
      fetchBannerData();
  }, []);
  const handlePlayPause = () => {
    if (bannerData.bannerType === "video" && bannerData.bannerVideoUrl.includes("youtube")) {
      setIsPlaying(!isPlaying);
    } else if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
        setIsPlaying(false);
      } else {
        videoRef.current.play();
        setIsPlaying(true);
      }
    }
  };
  useEffect(() => {
    sanityClient
      .fetch(
        `*[_type == "facility"]{
          "imageUrl": image.asset->url,
          "altText": image.alt
        }`
      )
      .then((data) => setFacilities(data))
      .catch(console.error);
  }, []);

    var settings3 = {
        dots: false,
        arrows: false,
        slidesToShow: 4,
        infinite: true,
        autoplay: true,
        slidesToScroll: 1,
        infinite: true,
        pauseOnHover: false,
        arrows: false,
        cssEase: "linear",
        autoplaySpeed: 0,
        speed: 8000,
        responsive: [
          {
            breakpoint: 2561,
            settings: {
              slidesToShow: 5,
            },
          },

          {
            breakpoint: 1500,
            settings: {
              slidesToShow: 4,
            },
          },

          {
            breakpoint: 991,
            settings: {
              slidesToShow: 4,
            },
          },
    
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 3,
            },
          },
    
          {
            breakpoint: 599,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      };


      var settings4 = {
        dots: false,
        arrows: false,
        slidesToShow: 2,
        infinite: true,
        autoplay: true,
        slidesToScroll: 1,
        infinite: true,
        pauseOnHover: false,
        arrows: false,
        cssEase: "linear",
        autoplaySpeed: 0,
        speed: 8000,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
            },
          },
    
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
            },
          },
    
          {
            breakpoint: 599,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      };

  return (
    <>
    {!isAbout && (
  <section className="home-facility">
        <div className="container">
            <div className="row align-items-center justify-content-between">

                <div className='col-lg-4'>
                    <div className='homefacility-head'>
                        <img src="./assets/home/choose-icon-3.png" alt="icon"/>
                        <h4 className='heading'>
                        {isAbout ? facilityContent?.heading : homeFacilityContent?.heading}
                        </h4>
                    </div>
                </div>

                <div className='col-lg-6 wow animate__animated animate__slideInUp' data-wow-duration="1s" data-wow-delay="0.1s">
                <p>{isAbout ? facilityContent?.description || 'No description available'
                  :
                  homeFacilityContent?.description}</p> 
                </div>

            </div>
        </div>
    </section>
     )}

{!isAbout && (
    <section className="mamu-videoarea">
        <div className="container">
            <div className="row">

                <div className='col-lg-6 col-md-6'>
                    <div className="expertise-video m-0">
                    {/* {bannerData && (
                       bannerData.bannerType === 'video' ? (
                        <>
                        <video 
                        className="img-responsive" 
                        src={bannerData.videoUrl} 
                        ref={videoRef}
                        muted 
                        loop 
                        playsInline 
                        alt={bannerData.altText}
                      />
                      </>):(
                        <img
                        src="/assets/home/facility-manu.webp"
                        alt="expert"
                        className="img-responsive"
                      />
                      )
                     )} */}

              {bannerData && (
                        <>
                          {!isPlaying ? (
                            <img
                              src={bannerData.imageUrl}
                              alt={bannerData.altText}
                              className="img-responsive" 
                              loading="lazy" width={"100%"} height={"100%"}
                            />
                          ) : bannerData.bannerType === "video" &&
                            bannerData.bannerVideoUrl.includes("youtube") ? (
                            <iframe
                              className="img-responsive"
                              src={`${bannerData.bannerVideoUrl}?autoplay=1&mute=1`}
                              title="YouTube Video"
                              frameBorder="0"
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                              allowFullScreen loading="lazy"
                            ></iframe>
                          ) : (
                            <video
                              className="img-responsive"
                              src={bannerData.bannerVideoUrl}
                              ref={videoRef}
                              muted
                              loop
                              playsInline
                            />
                          )}
                        </>
                      )}
                      {/* <Link
                        className="play-expert"
                        onClick={handlePlayPause}
                        aria-label={isPlaying ? "Pause video" : "Play video"}
                      >
                        <FontAwesomeIcon icon={isPlaying ? faPause : faPlay} />
                      </Link> */}
                        {/* <img src="/assets/home/facility-manu.webp" className='img-responsive' alt="expert"/> */}
                        {/* <Link to={""} className='play-expert'><FontAwesomeIcon icon={faPlay}/></Link> */}
                    </div>
                </div>

                <div className='col-lg-6 col-md-6'>
                  <div className='manu-imageslider facility-slider'>
                      <div>
                          <Slider {...settings4}>
                            {facilities.map((facility, index)=>(
                              <img src={facility.imageUrl} key={index} className='img-responsive' alt={facility.altText || "facility Image"} loading="lazy" width={"100%"} height={"100%"}/>
                            ))}
                          </Slider>
                      </div>
                  </div>
                </div>

            </div>
        </div>
    </section>
)}

   
    {isAbout &&(
    <section className='facility-slider'>
        <Slider {...settings3}>
          {facilities.map((facility, index)=>(
            <img src={facility.imageUrl} key={index} className='img-responsive' alt="facility" loading="lazy"/>
          ))}
            {/* <img src="./assets/home/facility-image-1.webp" className='img-responsive' alt="facility" />
 
            <img src="./assets/home/facility-image-2.webp" className='img-responsive' alt="facility" />
 
            <img src="./assets/home/facility-image-3.webp" className='img-responsive' alt="facility" />

            <img src="./assets/home/facility-image-4.webp" className='img-responsive' alt="facility" /> */}
        </Slider>
    </section>
    )}
    </>
  )
}
